import { stringToHTML } from '../utils/to-html';
import { $Q, $Qll } from '../utils/query-selector';
import { setQuantity } from "../utils/input-quantity";
import { btnAddToCart, deleteItem, onChangeItemCart, showErrorMessage } from "./cart";
import { barProgress } from '../utils/bar-progress';
import { sliderUpsell } from './slider-swiper';


/**
 * Update cart items section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateCartItems = (str) => {
  $Qll('.cartitems-js')
    .forEach(
      (element) => {
        element.innerHTML = $Q(
          '#cart-items',
          stringToHTML(str)
        ).outerHTML;
      }
    )

  setQuantity();
  deleteItem();
  onChangeItemCart();
  barProgress();
}

export const updateDiagnosticCartItems = async () => {
  const diagnosticCart = $Q('diagnostic-cart');
  if (!diagnosticCart) return;

  const sectionId = diagnosticCart.closest('.shopify-section')?.id.replace('shopify-section-', '');
  if (!sectionId) return;

  const response = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
  if (!response.ok) return;

  const freshCart = $Q('diagnostic-cart', stringToHTML(await response.text()));
  if (!freshCart) return;

  diagnosticCart.innerHTML = freshCart.innerHTML;
  document.dispatchEvent(new CustomEvent('update-diagnostic-cart'));

  setQuantity();
  deleteItem();
  onChangeItemCart();
  barProgress();
}

/**
 * Update checkout button section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateCartbutton = (str) => {
  const btnContainer = $Q('#cart-footer__button', stringToHTML(str));
  const inputBarProgress = $Q('.progress-bar__container', stringToHTML(str));
  const sideCart = $Q('.cart-wrapper');
  const domBtnContainer = $Qll('.cart-footer__button', sideCart);

  domBtnContainer.forEach( element => {
    element.innerHTML = btnContainer.outerHTML;
  });
}

/**
 * Update price item for each item in cart items section
 * @param {string} str - String HTML of section rendeirng
 * @param {number} id - Product ID
 * @param {String} itemKey - Product itemKey
 */
export const updatePriceItem = (str, id, itemKey) => {
  const section = stringToHTML(str);
  if (!section) return;

  const fetchedParentItem =
    $Q(`.js-cart-item[data-live-item-key="${itemKey}"]`, section) ||
    $Q(`#price-${id}`, section)?.closest('.js-cart-item');

  if (!fetchedParentItem) return;

  const newPriceNode = $Q(`#price-${id}`, fetchedParentItem);
  if (!newPriceNode) return;

  return $Qll(`.js-cart-item[data-live-item-key="${itemKey}"]`).forEach((element) => {
    const priceItemSpan = $Q('.cart-item__price', element);
    if (!priceItemSpan) return;
    const currentPriceNode = $Q(`#price-${id}`, element);
    if (currentPriceNode) {
      currentPriceNode.innerHTML = newPriceNode.innerHTML;
    } else {
      priceItemSpan.innerHTML = newPriceNode.outerHTML;
    }
  });
}

/**
 * update cart item for each item in cart items section
 * @param {String} str String HTML of section rendeirng
 * @param {String} itemKey Product itemKey
 */
 export const updateCartItem = (str, itemKey) => {
  const section = stringToHTML(str);
  if (!section) return;

  const targetItem = `.js-cart-item[data-live-item-key="${itemKey}"] .item-cart-js input`;
  let fetchedInput = $Q(targetItem, section);

  if (!fetchedInput) {
    const currentInput = $Q(`${targetItem}`, document);
    const inputId = currentInput?.getAttribute('id');
    if (inputId) fetchedInput = $Q(`.item-cart-js input[id="${inputId}"]`, section);
  }

  const inputValue = fetchedInput?.value;
  if (typeof inputValue === 'undefined') return;

  $Qll(`.js-cart-item[data-live-item-key="${itemKey}"]`).forEach((element) => {
    element.querySelector('.item-cart-js input').value = inputValue;
  });
};

/**
 * Update total price in cart page
 * @param {string} str - String HTML of section rendeirng
 */
export const updatetotalPrice = (str) => {
  const totalPriceElements = [
    '#total-price',
    '.cart-footer__prices-total',
    '#jc-cart-delivery-info'
  ] 

  totalPriceElements.forEach(element => {
    if($Qll(element)){
      return $Qll(element).forEach(item => {
        item.innerHTML = $Q(
          element,
          stringToHTML(str)
        ).innerHTML;
      });
    }
  })
}

/**
 * Update recommended section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateRecommended = (str) => {

  let recommendedJS = $Q('#jc-related-products-inner');

  if(!recommendedJS) return;

  const fetchedRecommended = $Q('#jc-related-products-inner', stringToHTML(str));

  if (!fetchedRecommended) return;

  recommendedJS.innerHTML = fetchedRecommended.innerHTML;

  btnAddToCart(".add-product-cart-upsell");
}
 

/**
 * Update upsell section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateUpsell = (str) => {

  let upsellJS = $Q('#upsell-js');

  if(!upsellJS) return;

  upsellJS.innerHTML = $Q(
    '#cart-upsell-slider',
    stringToHTML(str)
  ).outerHTML;

  btnAddToCart(".add-product-cart-upsell");
  sliderUpsell();
}

/**
 * Update promocode section in sidecart
 * @param {string} str - String HTML of section rendering
 */
export const updatePromocode = (str) => {
  const promocodeContainer = $Q('#cart-promocode-container');

  if (!promocodeContainer) return;

  const newPromocode = $Q('#cart-promocode-container', stringToHTML(str));

  if (!newPromocode) return;

  promocodeContainer.innerHTML = newPromocode.innerHTML;
}

/**
 * Update cart quantity
 * @param {String} str - String HTML of section rendeirng
 */
export const updateCartQuantity = (str) => {
  const value = $Q(
    '#cart_items_count',
    stringToHTML(str)) && $Q('#cart_items_count',stringToHTML(str)).value;

  const quantityItems = $Qll('.cart-button__item-qty');

  quantityItems.forEach(quantityItem => {
  updateHeaderCartQuantity(value, quantityItem);
  return quantityItem.innerHTML = value;
})
};

/**
 * Update header cart quantity
 * @param {number} value - items quantity
 * @param {HTMLElement} item - item which is going to be modified
 */
const updateHeaderCartQuantity = (value, item) => {
  if(!item) return;

  value > 0
    ? item.classList.add('cart-button__item-qty--not-empty')
    : item.classList.remove('cart-button__item-qty--not-empty')
}

/**
 * Update empty cart
 * @param {String} str - String HTML of section rendeirng
 */
export const updateEmptyCart = (str) => {
  const section = stringToHTML(str);
  if(typeof window === 'undefined'|| !section) return;

  if(window.location.pathname.includes('cart')) {
    updateEmptyCartPage(section);
  }

  updateEmptySideCart(section);
};

const updateEmptySideCart = (section) => {
  const cartWrapper = $Q('.cart-wrapper');
  const cartFixed = $Q('.cart__fixed');
  if(!cartWrapper) return;

  const items = $Q('#cart-items', section) && $Q('#cart-items', section).children;

  if(items && !items.length) {
    cartWrapper.classList.add('cart-wrapper--empty');
  } else {
    cartWrapper.classList.remove('cart-wrapper--empty');
  }
}

const updateEmptyCartPage = () => {
  const cartPage = $Q('.cart-page');
  if(!cartPage) return;

  const items = $Q('#cart-items', cartPage) && $Q('#cart-items', cartPage).children;
  const cartEmptyInfo = $Q('.cart-empty', cartPage);

  if(!items || !cartEmptyInfo) return;

  if(items && !items.length) {
    cartPage.classList.add('cart-page--empty');
    cartEmptyInfo.classList.remove('hidden');
    updateEmptyCartTitle(true);
  } else {
    cartPage.classList.remove('cart-page--empty');
    cartEmptyInfo.classList.add('hidden');
    updateEmptyCartTitle();
  }
}

const updateEmptyCartTitle = (empty) => {
  const cartPage = $Q('.cart-page');

  if(!cartPage) return;

  const wrapper = $Q('.wrapper', cartPage);

  if(!wrapper) return;

  let title;

  empty
    ? title = wrapper.dataset.emptyTitle
    : title = wrapper.dataset.title

  const titleElement = $Q('.cart-page__title');
  if(!titleElement) return;
  titleElement.innerHTML = title;
}

/**
 * This checks variant inventory quantity and policy,
 * to allow or disallow continue increasing the quantity of
 * the product
 * @param {HTMLElement} input - It's the input updated in cart
 * @returns {boolean} - returns true if last condition is true, otherwise undefined
 */
export const checkQuantity = (input) => {
  const dataset = input && input.dataset;

  if(!dataset) return;

  if(!dataset.quantity || !dataset.policy) return;

  if(dataset.policy === 'continue') return;

  const { breakAdd, totalQuantity } = getAllVariantsQuantity(
    input,
    dataset.quantity);

  const description =
    `Vos ${totalQuantity} ${dataset.product} ` +
    'ont été ajouté(e)s à votre panier.';

  if(breakAdd) {
    showErrorMessage(description);
    return true;
  }
}

/**
 * It totalize all the same variant quantities
 * @param {HTMLElement} input - It's the input updated in cart
 * @returns {Object}
 *  breakAdd {boolean} - If the totalQuantity is greater or equal
*                        than inventory quantity
 *  totalQuantity {number} - It's the sum of all quantities
 */
const getAllVariantsQuantity = (input, quantity) => {
  const id = input && input.getAttribute('id');

  const parent = $Q('.cart-wrapper');
  const inputs = $Qll(`[id="${id}"]`, parent);

  const totalQuantity = inputs.reduce((acc,curr) => (
    acc + parseInt(curr.value)
  ), 0)

  return {
    breakAdd: totalQuantity >= parseInt(quantity),
    totalQuantity
  }
}
